<template>
  <div>
    <h3 class="_header">修复录入</h3>
    <el-form
      ref="refForm"
      :model="form"
      label-position="left"
      label-width="80px"
      :rules="formRules"
    >
      <el-form-item label="XF号: " prop="qc" style="width:380px">
        <el-input v-model="form.qc"></el-input>
      </el-form-item>
      <el-form-item label="打标id: " prop="re_dbids" style="width:380px">
        <el-input
          v-model="dbid_str"
          type="number"
          :controls="false"
          style="width:300px"
          @keyup.native.enter="formatDbid"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-tag
          v-for="item in form.re_dbids"
          :key="item"
          closable
          :hit="true"
          type="success"
          style="margin-right:10px"
          @close="handleClose(item)"
          >{{ item }}</el-tag
        >
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dbid_str: "",
      form: {
        qc: "",
        re_dbids: [],
      },

      formRules: {
        qc: [
          {
            required: true,
            message: "请输入修复号",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^XF\d{3}$/.test(value))
                return callback(new Error("XF号格式错误, 正确格式： XF001"));
            },
            trigger: "change",
          },
        ],

        re_dbids: [
          // { required: true, message: '请输入打标id', trigger: 'blur' }
        ],
      },
    };
  },

  methods: {
    submit() {
      if (this.form.re_dbids.length == 0)
        return this.$message.error("请输入dbid");
      try {
        this.$refs.refForm.validate(valid => {
          if (!valid) throw new Error(false);
        });
        // this.$http.post('/erp/QualityChecking/pcRepair', this.form).then(rs=>{
        this.$http.post("/erp/QualityChecking/repair", this.form).then(rs => {
          if (rs.data.code != 200) {
            return this.$message.error(rs.data.msg);
          }
          this.$message.success(rs.data.msg);
          this.$set(this.form, "re_dbids", []);
          // this.$refs.refForm.$el.children[1].focus();
          // this.$refs.refForm.$el.children[1].select();
        });
      } catch (e) {}
    },

    formatDbid() {
      if (!this.dbid_str) return;
      let _dbid = this.dbid_str.trim("dbid=");
      if (!this.form.re_dbids.includes(_dbid))
        this.$set(this.form.re_dbids, this.form.re_dbids.length, _dbid);

      this.dbid_str = "";
      // this.$refs.refForm.resetField()
    },

    handleClose(tag) {
      // console.log('remove', tag);
      this.form.re_dbids.splice(this.form.re_dbids.indexOf(tag), 1);
      // this.$delete(this.form.dbids, this.form.dbids.indexOf(tag));
    },
  },
};
</script>
<style scoped>
._header {
  height: 36px;
  background-color: #e8e8e8;
  padding: 0 20px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/pages/quality/Check.vue